import { useEffect, useRef, useState } from 'react';

/**
 * Detects whether an element's content is horizontally truncated.
 *
 * Uses a ResizeObserver to re-check whenever the element's size changes
 * (e.g. on window resize or column width adjustment).
 *
 * Returns a ref to attach to the element and a boolean indicating
 * whether its content overflows (scrollWidth > clientWidth).
 */
export const useTruncationDetection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const check = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    check();

    const observer = new ResizeObserver(check);
    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return { ref, isTruncated };
};
